interface FacebookSelfResponse {
  name?: string;
  error?: unknown;
}

export const LOGIN_NAME_TIMEOUT_MS = 5000;

/**
 * Resolves the name of the Facebook account active in the browser, so a reconnect failure can
 * name it. Mirrors `instagram-business.js`'s `fetchFacebookSelf`.
 *
 * Resolves to `undefined` rather than rejecting on any failure — this only decorates an error
 * that is already being reported, and must never swallow it. That includes the callback never
 * firing: `FB.api` does not guarantee it, and a promise that never settles would strand the
 * reconnect dropTask awaiting it.
 */
export function fetchFacebookLoginName(timeoutMs = LOGIN_NAME_TIMEOUT_MS): Promise<string | undefined> {
  return new Promise((resolve) => {
    if (typeof FB === 'undefined') {
      resolve(undefined);
      return;
    }

    const timeoutId = setTimeout(() => resolve(undefined), timeoutMs);

    const settle = (name?: string): void => {
      clearTimeout(timeoutId);
      resolve(name);
    };

    try {
      FB.api('/me', { fields: 'name' }, (response?: FacebookSelfResponse) => {
        settle(response && !response.error ? response.name : undefined);
      });
    } catch {
      settle(undefined);
    }
  });
}
